/* GoGo Solar — brand name swap.

   The homepage is a React app that owns its own DOM, so the old name cannot
   simply be edited out of a template. This walks the rendered page and
   replaces it, then keeps watching because React re-renders.

   Two guards stop this looping forever: text is only touched when it still
   contains the old name, and the logo image is marked once it has been
   handled. Once everything is swapped, a pass changes nothing and the
   observer goes quiet. */
(function () {
  var OLD = /Bright\s+Solar\s+Lights/g;
  var NEW = "GoGo Solar";
  var GOLD = "#F5A800";
  var STYLE_ID = "bsl-brandname-style-v1";

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      ".bsl-wordmark{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:900;" +
        "font-size:1.35rem;letter-spacing:-.025em;line-height:1;color:currentColor;" +
        "white-space:nowrap;display:inline-block}",
      ".bsl-wordmark span{color:" + GOLD + "}",
      "[data-bsl-dupe]{display:none !important}"
    ].join("");
    document.head.appendChild(s);
  }

  /* Swap the old name wherever it appears as visible text. */
  function swapText(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf("Bright") === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        var p = n.parentNode;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.nodeName;
        if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT") {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var hits = [];
    var n;
    while ((n = walker.nextNode())) hits.push(n);
    for (var i = 0; i < hits.length; i++) {
      OLD.lastIndex = 0;
      if (OLD.test(hits[i].nodeValue)) {
        OLD.lastIndex = 0;
        hits[i].nodeValue = hits[i].nodeValue.replace(OLD, NEW);
      }
    }
  }

  /* Attributes people actually see or that search engines read. */
  function swapAttrs() {
    var els = document.querySelectorAll("[alt],[title],[aria-label],[placeholder]");
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      ["alt", "title", "aria-label", "placeholder"].forEach(function (a) {
        var v = e.getAttribute(a);
        if (v && v.indexOf("Bright") !== -1) {
          OLD.lastIndex = 0;
          e.setAttribute(a, v.replace(OLD, NEW));
        }
      });
    }
  }

  /* The header still carries the old logo image. Until the new artwork
     arrives, set the name in type so nothing on screen says the old brand. */
  function swapLogo() {
    var imgs = document.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute("data-bsl-brand")) continue;
      var src = img.getAttribute("src") || "";
      if (src.indexOf("/logo.png") === -1) continue;

      img.setAttribute("data-bsl-brand", "1");

      var mark = document.createElement("span");
      mark.className = "bsl-wordmark";
      mark.setAttribute("data-bsl-brand", "1");
      mark.innerHTML = "GoGo<span>Solar</span>";

      if (img.parentNode) {
        img.parentNode.insertBefore(mark, img);
        img.style.display = "none";
      }
    }
  }

  /* The header also prints the shop name as plain text next to the logo, so
     once the styled wordmark is in you see it twice. Hide the plain one.
     Scoped to the header around the wordmark so nothing else that happens to
     read "GoGo Solar" gets hidden by accident. */
  function hideDuplicateName() {
    var marks = document.querySelectorAll(".bsl-wordmark");
    for (var i = 0; i < marks.length; i++) {
      var mark = marks[i];
      var scope = null;
      try { scope = mark.closest("header") || mark.closest("a"); } catch (e) {}
      if (!scope) scope = mark.parentElement;
      if (!scope) continue;

      var els = scope.querySelectorAll("span,div,p,h1,h2,strong");
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        if (el === mark) continue;
        if (el.getAttribute("data-bsl-dupe")) continue;
        if (el.classList && el.classList.contains("bsl-wordmark")) continue;
        if (el.contains(mark)) continue;
        if (el.querySelector && el.querySelector(".bsl-wordmark")) continue;

        var t = (el.textContent || "").replace(/\s+/g, " ").trim();
        if (t === "GoGo Solar" || t === "GoGoSolar") {
          el.setAttribute("data-bsl-dupe", "1");
          el.style.display = "none";
        }
      }
    }
  }

  function run() {
    styles();
    try {
      swapText(document.body);
      swapAttrs();
      swapLogo();
      hideDuplicateName();
    } catch (e) {}
    if (document.title && document.title.indexOf("Bright") !== -1) {
      OLD.lastIndex = 0;
      document.title = document.title.replace(OLD, NEW);
    }
  }

  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
